import entity from '../../../models/cms/pages'

export default [
  {
    path: '/pages',
    meta: {
      entity,
      requiresPermissionTo: 'pages',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/pages/new',
    meta: {
      entity,
      requiresPermissionTo: 'pages',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/pages/:id',
    meta: {
      entity,
      requiresPermissionTo: 'pages',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
